.prose {
  font-size: var(--text-base);
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
}

.editable {
  cursor: text;
  border-radius: var(--radius-sm);
  transition: background var(--duration-fast) var(--ease-default);
}

.editable:hover {
  background: var(--bg-elevated);
  box-shadow: 0 0 0 6px var(--bg-elevated);
}

.para {
  margin: 0 0 var(--space-3) 0;
}

.para:last-child {
  margin-bottom: 0;
}

.list {
  margin: 0 0 var(--space-3) 0;
  padding-left: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.list:last-child {
  margin-bottom: 0;
}

.prose strong {
  color: var(--text-primary);
  font-weight: var(--weight-semi);
}

/* ── Variants ─────────────────────────────────────────────── */

.headingText {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-xl);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  color: var(--text-primary);
  line-height: 1.25;
}

/* A section heading is a divider as much as a label — the rule under it is
   what makes a long document scannable. */
.heading {
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: var(--space-2);
}

.callout {
  padding: var(--space-4);
  border-left: 3px solid var(--ai-accent);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  background: var(--ai-surface);
  color: var(--text-primary);
}

/* ── Editing ──────────────────────────────────────────────── */

.editor {
  display: block;
  width: 100%;
  min-height: 72px;
  padding: var(--space-2);
  background: var(--bg-elevated);
  border: 1px solid var(--ai-accent);
  border-radius: var(--radius-md);
  outline: none;
  resize: none;
  overflow: hidden;
  font-family: var(--font-sans);
  font-size: var(--text-base);
  color: var(--text-primary);
  line-height: var(--leading-relaxed);
}

/* The wrapper's accent border is the focus signal; global.css would otherwise
   paint a second, yellow ring on top of it. */
.editor:focus-visible {
  outline: none;
}

.editor.heading {
  font-size: var(--text-xl);
  font-weight: var(--weight-bold);
  border-bottom: 1px solid var(--ai-accent);
  min-height: 48px;
}

.empty {
  display: block;
  width: 100%;
  padding: var(--space-3);
  background: none;
  border: 1px dashed var(--border-default);
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-size: var(--text-base);
  color: var(--text-muted);
  text-align: left;
  cursor: text;
}

.empty:hover {
  border-color: var(--ai-accent);
  color: var(--text-secondary);
}
